export default{
  // apihost:'http://192.168.15.31:8090', // 生产
  apihost:'http://123.207.73.192:8090', // 测试
}



// WEBPACK FOOTER //
// ./src/components/api.js